import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const jwt = sessionStorage.getItem('jwt');
    if (jwt) {
      const cloned = req.clone({
        setHeaders: { Authorization: `Bearer ${jwt}` }
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
